import request from "@/config/utils/request";

export function getData(data) {
  return request({
    url: "/apis/statistic/order/org",
    method: "post",
    data
  });
}
// 编制单位接口
export function qryUnitOrgTree(data) {
  return request({
    url: "/apis/demo/qryOrgTree",
    method: "post",
    data
  });
}
// 定标采购方案统计表（purchase-list.vue）
export function getList(data) {
  return request({
    url: "/apis/statistic/purchase/org",
    method: "post",
    data
  });
}
